import { render, staticRenderFns } from "./JVxeDemo1.vue?vue&type=template&id=64ed9586&scoped=true&"
import script from "./JVxeDemo1.vue?vue&type=script&lang=js&"
export * from "./JVxeDemo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed9586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ed9586')) {
      api.createRecord('64ed9586', component.options)
    } else {
      api.reload('64ed9586', component.options)
    }
    module.hot.accept("./JVxeDemo1.vue?vue&type=template&id=64ed9586&scoped=true&", function () {
      api.rerender('64ed9586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/JVxeDemo1.vue"
export default component.exports